import React, { useContext } from 'react';

import firebase, { db } from '../../firebase/base';
import { AuthContext } from '../../contexts/auth.context';
import { FavoritesContext } from '../../contexts/favorites.context';

import { Button } from './SubscribeButton.styles';

import { FaRegHeart, FaHeart } from 'react-icons/fa';

const SubscribeButton = ({ title, publisher, thumbnail, id, className }) => {
  const { currentUser } = useContext(AuthContext);
  const { favoritesID } = useContext(FavoritesContext);
  // Check if user has added this podcast in favorites
  const inFavorites = id in favoritesID;

  const handleClick = () => {
    let subscribedRef = db.collection('subscribed').doc(currentUser.uid);

    if (inFavorites) {
      subscribedRef.update({
        [id]: firebase.firestore.FieldValue.delete()
      });
    } else {
      subscribedRef.set(
        {
          [id]: {
            title,
            publisher,
            thumbnail,
            id,
            addedAt: new Date().toISOString()
          }
        },
        { merge: true }
      );
    }
  };

  if (currentUser) {
    return (
      <Button
        inFavorites={inFavorites}
        onClick={handleClick}
        className={className}
      >
        {inFavorites ? <FaHeart /> : <FaRegHeart />}
      </Button>
    );
  } else return <></>;
};

export default SubscribeButton;
